// Document navigation is separate from URL construction and session cleanup so
// browser integration tests can observe redirects without unloading the page.
export const browserNavigation = {
  assign: (url: string): void => window.location.assign(url),
  replace: (url: string): void => window.location.replace(url),
};
